import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgConfirmedCircle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 10a8.75 8.75 0 1117.501.001A8.75 8.75 0 011.25 10zm12.291-3.4a.4.4 0 01.567.002l.611.615a.4.4 0 010 .565l-6.103 6.102a.4.4 0 01-.566 0l-2.767-2.768a.4.4 0 010-.565l.61-.61a.4.4 0 01.565 0l1.875 1.867 5.208-5.207z"
      />
    </Icon>
  );
};

export default SvgConfirmedCircle;
